import { configureStore } from '@reduxjs/toolkit'
import authReducer from "../features/auth";
import kycReducer from "../features/KycSlice";
import uploadedDocumentsReducer from "../features/UploadedDocumentsSlice";
import messageReducer from "../features/message";
import {kycAPI} from '../services/kycAPI';
import {ApiRoutes} from '../services/ApiRoutes';
import {MyroutesAPI} from '../services/MyroutesAPI';
import {userSlice} from '../features/userSlice';
import ApiRoutesReducer from '../features/ApiRoutesSlice';
import MyCollectionReducer from '../features/MyCollectionSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    message: messageReducer,
    kyc: kycReducer,
    uploadedDocuments: uploadedDocumentsReducer,
    routes: ApiRoutesReducer,
    collection: MyCollectionReducer,
    [kycAPI.reducerPath]: kycAPI.reducer,
    [ApiRoutes.reducerPath]: ApiRoutes.reducer,
    [MyroutesAPI.reducerPath]: MyroutesAPI.reducer,
    user: userSlice.reducer,
  }
})
export default store;